import type { ReactElement } from 'react';

import { DealKanbanPage } from '../features/deals/pages/DealKanbanPage.js';

export default function DealsPage(): ReactElement {
  return <DealKanbanPage />;
}
